import { render } from "./File.vue?vue&type=template&id=77c200d6&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import "./File.vue?vue&type=style&index=0&id=77c200d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c200d6"]])

export default __exports__